export class Authenticator {
    constructor(authenticator) {
        this.meta = authenticator;
    }
}
